// extracted by mini-css-extract-plugin
module.exports = {"avatar":"GetStartedView_avatar__3b5dH","account":"GetStartedView_account__10phi","serverlist":"GetStartedView_serverlist__3dV7n"};